import React from 'react';
import cn from 'classnames';
import PT from 'prop-types';

const Button = ({
                    text = '',
                    icon,
                    variant = 'primary',
                    disabled,
                    onClick,
                    className,
                    type = 'button',
                    size,
                    hasBorder = true,
                    dataTestId
                }) => {
    const iconClass = cn('button__icon icon', icon);

    return (
        <button
            data-testid={dataTestId}
            disabled={disabled}
            className={cn(
                'button',
                {
                    [`button_${size}`]: size,
                    'button_primary': variant === 'primary',
                    'button_secondary': variant === 'secondary',
                    'button_disabled': disabled,
                    'button_no-icon': !Boolean(icon),
                    'button_no-border': !hasBorder
                },
                className
            )}
            onClick={onClick}
            type={type}
        >
            {icon && (
                <span className={iconClass}></span>
            )}
            {text}
        </button>
    );
};

Button.propTypes = {
    text: PT.oneOfType([PT.string, PT.number]),
    icon: PT.string,
    variant: PT.oneOf(['primary', 'secondary']),
    disabled: PT.bool,
    onClick: PT.func,
    className: PT.string,
    size: PT.string,
    type: PT.oneOf(['submit', 'reset', 'button'])
};

export default Button;
